/* eslint-disable react/prop-types */
/* eslint-disable react/function-component-definition */

// src/sectors/pilates/staff/table/staffTableData.js (path sende farklı olabilir)

import React from 'react';
import Icon from '@mui/material/Icon';
import Tooltip from '@mui/material/Tooltip';

import MDBox from 'components/MDBox';
import MDTypography from 'components/MDTypography';
import MDAvatar from 'components/MDAvatar';
import MDBadge from 'components/MDBadge';

import { roleLabel, workTypeLabel, statusChip } from '../utils/staffFormatters';

// ✅ merkezi perms: tek gerçek kaynak
import { PERMS_SCHEMA, buildQuickPermIcons, normalizePerms } from '../permission/permsSchema'; // path sende farklıysa düzelt

function initials(name = '') {
  const p = String(name || '')
    .trim()
    .split(' ')
    .filter(Boolean);
  const a = (p[0]?.[0] || '').toUpperCase();
  const b = (p[1]?.[0] || '').toUpperCase();
  return a + b || 'U';
}

// ✅ login panel badge helper
function loginChip(staff) {
  const hasAccount = Boolean(staff?.hasLoginAccount || staff?.username);

  if (!hasAccount) return { label: 'Yok', color: 'secondary', icon: 'person_off' };

  const st = staff?.loginStatus; // "ACTIVE" | "SUSPENDED" | null
  if (st === 'SUSPENDED') return { label: 'Kapalı', color: 'error', icon: 'lock' };

  return { label: 'Açık', color: 'success', icon: 'check_circle' };
}

// ✅ quick icon listesi: module-level (her render’da hesaplanmasın)
const QUICK_PERM_ICONS = buildQuickPermIcons(PERMS_SCHEMA, 6);

// ✅ permissions icon row
function PermIcons({ perms }) {
  // normalize => eksik keyler default'a tamamlanır
  const p = normalizePerms(perms, PERMS_SCHEMA);

  return (
    <MDBox
      display="flex"
      alignItems="center"
      gap={0.75}
      sx={{ flexWrap: 'wrap', justifyContent: 'center' }}
    >
      {QUICK_PERM_ICONS.map((it) => {
        const ok = Boolean(p?.[it.key]);
        return (
          <Tooltip
            key={it.key}
            title={`${it.label}: ${ok ? 'Açık' : 'Kapalı'}`}
            placement="top"
            arrow
          >
            <MDBox
              sx={(theme) => ({
                width: 28,
                height: 28,
                borderRadius: '10px',
                display: 'grid',
                placeItems: 'center',
                border: `1px solid ${theme.palette.divider}`,
                background: ok ? theme.palette.action.hover : 'transparent',
                opacity: ok ? 1 : 0.35,
                cursor: 'default',
              })}
            >
              <Icon sx={{ fontSize: 16 }}>{it.icon}</Icon>
            </MDBox>
          </Tooltip>
        );
      })}
    </MDBox>
  );
}

export default function staffTableData({ items = [], onOpenMenu, onOpenDetail }) {
  const Person = ({ staff }) => {
    const inits = initials(staff?.fullName);

    // backend dto: staffRole
    const role = staff?.staffRole ?? staff?.role;
    const workType = staff?.workType;

    return (
      <MDBox display="flex" alignItems="center" lineHeight={1} sx={{ minWidth: 0 }}>
        <MDAvatar
          bgColor="info"
          size="sm"
          sx={{
            borderRadius: '12px',
            fontWeight: 800,
            letterSpacing: '0.02em',
          }}
        >
          {inits}
        </MDAvatar>

        <MDBox ml={2} lineHeight={1} sx={{ minWidth: 0 }}>
          <MDTypography
            display="block"
            variant="button"
            fontWeight="bold"
            sx={{ whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}
          >
            {staff?.fullName || '-'}
          </MDTypography>

          <MDTypography variant="caption" sx={{ opacity: 0.85 }}>
            {roleLabel(role)} • {workTypeLabel(workType)}
          </MDTypography>
        </MDBox>
      </MDBox>
    );
  };

  return {
    columns: [
      { Header: 'eğitmen', accessor: 'person', align: 'left' },
      { Header: 'panel', accessor: 'login', align: 'center' },
      { Header: 'izinler', accessor: 'perms', align: 'center' },
      { Header: 'e-posta', accessor: 'email', align: 'left' },
      { Header: 'telefon', accessor: 'phone', align: 'left' },
      { Header: 'durum', accessor: 'status', align: 'center' },
      { Header: 'işlem', accessor: 'action', align: 'center' },
    ],

    rows: (items || []).map((s) => {
      const st = statusChip(s?.active);
      const lg = loginChip(s);

      return {
        person: (
          <MDBox
            component="a"
            href="#"
            onClick={(e) => {
              e.preventDefault();
              onOpenDetail?.(s);
            }}
            sx={{ textDecoration: 'none' }}
          >
            <Person staff={s} />
          </MDBox>
        ),

        login: (
          <MDBox display="inline-flex" alignItems="center" gap={0.75}>
            <Icon sx={{ fontSize: 16, opacity: 0.9 }}>{lg.icon}</Icon>
            <MDBadge badgeContent={lg.label} color={lg.color} variant="gradient" size="sm" />
          </MDBox>
        ),

        perms: <PermIcons perms={s?.permissions} />,

        email: (
          <MDTypography variant="button" fontWeight="medium" sx={{ opacity: 0.9 }}>
            {s?.email || '-'}
          </MDTypography>
        ),

        phone: (
          <MDTypography variant="button" fontWeight="medium" sx={{ opacity: 0.9 }}>
            {s?.phone || '-'}
          </MDTypography>
        ),

        status: (
          <MDBox ml={-1} display="inline-flex">
            <MDBadge badgeContent={st.label} color={st.color} variant="gradient" size="sm" />
          </MDBox>
        ),

        action: (
          <MDTypography
            component="a"
            href="#"
            color="text"
            onClick={(e) => {
              e.preventDefault();
              onOpenMenu?.(e, s);
            }}
          >
            <Icon>more_vert</Icon>
          </MDTypography>
        ),
      };
    }),
  };
}
